/**
 * Generates a default profile picture a la GMail using the text inputed.
 *
 * @param {String} text Text to be used in the letter profile picture
 * @return {String} Base 64 encoded SVG image
 */
function generateDefaultProfilePicture(text) {
    if (!text) {
        return;
    }

    // Same colors as in the app!
    const alphabetColors = [
        "#64C2AC",
        "#70DAC1",
        "#4FBDEE",
        "#71D2FD",
        "#7F7FF1",
        "#BCC4DA",
        "#64C2AC",
        "#70DAC1",
        "#4FBDEE",
        "#71D2FD",
        "#7F7FF1",
        "#BCC4DA",
        "#64C2AC",
        "#70DAC1",
        "#4FBDEE",
        "#71D2FD",
        "#7F7FF1",
        "#BCC4DA",
        "#64C2AC",
        "#70DAC1",
        "#4FBDEE",
        "#71D2FD",
        "#7F7FF1",
        "#BCC4DA",
        "#64C2AC",
        "#70DAC1",
        "#4FBDEE",
    ];

    let color;
    if (text.charCodeAt(0) < 65) {
        color = "#9A89B5";
    } else {
        let colorIndex = Math.floor((text.charCodeAt(0) - 65) % alphabetColors.length);
        color = alphabetColors[colorIndex];
    }

    return `data:image/svg+xml;base64,${Buffer.from(
        `<svg xmlns="http://www.w3.org/2000/svg" pointer-events="none" width="60" height="60" style="background-color: ${color}; width: 60px; height: 60px;"><text text-anchor="middle" y="50%" x="50%" dy="0.35em" pointer-events="auto" fill="#ffffff" font-family="HelveticaNeue-Light,Helvetica Neue Light,Helvetica Neue,Helvetica, Arial,Lucida Grande, sans-serif" style="font-weight: 400; font-size: 22px;">${text.replace(
            "&",
            "",
        )}</text></svg>`,
    ).toString("base64")}`;
}

export default generateDefaultProfilePicture;
